/* Talking to the Definable extension from this page: Chrome lets a page message an
   extension whose manifest names the page's origin (`externally_connectable`). The
   extension's id is the build's (REACT_APP_EXTENSION_ID); without it, or without the
   extension, the page falls back to the link to paste. */

const WAIT_MS = 1500;

interface Runtime {
  sendMessage: (id: string, message: unknown, reply: (answer?: { ok?: boolean }) => void) => void;
  lastError?: unknown;
}

const runtime = () => (window as unknown as { chrome?: { runtime?: Runtime } }).chrome?.runtime;

/** The extension's answer, or null: not installed, an id this build lacks, no answer. */
export function askExtension(message: { ping: true } | { add: string }): Promise<{ ok?: boolean } | null> {
  const chrome = runtime();
  const id = process.env.REACT_APP_EXTENSION_ID; // read here: the build inlines it, a test sets it
  if (!id || !chrome?.sendMessage) return Promise.resolve(null);
  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve(null), WAIT_MS);
    try {
      chrome.sendMessage(id, message, (answer) => {
        clearTimeout(timer);
        resolve(chrome.lastError ? null : (answer ?? null));
      });
    } catch {
      clearTimeout(timer);
      resolve(null); // Chrome throws for an id no extension has: the same as not installed
    }
  });
}
